import { cn } from '@/lib/cn'
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'

interface MedicationGridProps {
  medications: Array<{ name: string; nameLabel: string; quantity: number; unit: string; status: 'normal' | 'alert' | 'critical' }>
  onUpdate: (name: string, quantity: number) => void
}

export function MedicationGrid({ medications, onUpdate }: MedicationGridProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
      {medications.map((med) => {
        const statusColors = {
          normal: 'bg-success-50 border-success-200',
          alert: 'bg-warning-50 border-warning-200',
          critical: 'bg-error-50 border-error-200',
        }
        const textColors = {
          normal: 'text-success-700',
          alert: 'text-warning-700',
          critical: 'text-error-700',
        }
        return (
          <div key={med.name} className={cn('rounded-lg border p-3 flex flex-col items-center gap-2 transition-colors', statusColors[med.status])}>
            <span className={cn('text-xs font-semibold text-center', textColors[med.status])}>{med.nameLabel}</span>
            <div className="flex items-center gap-1">
              <button
                type="button"
                onClick={() => onUpdate(med.name, Math.max(0, med.quantity - 1))}
                className={cn('w-7 h-7 rounded border flex items-center justify-center hover:bg-white/50 transition-colors border-current/20', textColors[med.status])}
              >
                <MinusIcon className="w-3.5 h-3.5" />
              </button>
              <span className={cn('w-8 text-center text-lg font-bold tabular-nums', textColors[med.status])}>{med.quantity}</span>
              <button
                type="button"
                onClick={() => onUpdate(med.name, med.quantity + 1)}
                className={cn('w-7 h-7 rounded border flex items-center justify-center hover:bg-white/50 transition-colors border-current/20', textColors[med.status])}
              >
                <PlusIcon className="w-3.5 h-3.5" />
              </button>
            </div>
            <span className="text-[10px] text-neutral-400">{med.unit}</span>
          </div>
        )
      })}
    </div>
  )
}
